import type { FC } from 'react';
import React from 'react';
import { Box } from '@edreamsodigeo/prisma-design-system';

import FreeCancellationBanner from '@/components/FreeCancellation/BannerMessage/FreeCancellationBannerMessage';
import RibbonWithMessage from '@/components/FreeCancellation/RibbonWithMessage';
import { useFreeCancellationDrawerActions } from '@/clientState/providers/FreeCancellationDrawerProvider';

interface FreeCancellationBannerMobileProps {
  labelPage: string;
}

export const FreeCancellationBannerMobile: FC<
  FreeCancellationBannerMobileProps
> = ({ labelPage }) => {
  const { open } = useFreeCancellationDrawerActions();

  return (
    <>
      <Box position="relative">
        <Box position="absolute" sx={{ transform: 'translate(-24px, -50%)' }}>
          <RibbonWithMessage />
        </Box>
        <Box
          overflow="hidden"
          borderTopLeftRadius="regular"
          borderTopRightRadius="regular"
        >
          <Box borderRadius="regular" overflow="hidden">
            <FreeCancellationBanner
              showMoreInfo
              onMoreInfoClick={open}
              labelPage={labelPage}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};
